import { render } from "./ProfileUserMenu.vue?vue&type=template&id=4f81f606"
import script from "./ProfileUserMenu.vue?vue&type=script&lang=js"
export * from "./ProfileUserMenu.vue?vue&type=script&lang=js"

import "./ProfileUserMenu.vue?vue&type=style&index=0&id=4f81f606&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__